export enum FileUploadErrorsEnum {
  INVALID_FILE_TYPE = 'Invalid File Type',
  EXCEEDS_FILE_SIZE_LIMIT = 'Exceeds File Size Limit',
  NO_ERROR = '',
}
